import { useEffect } from 'react';
import { useErrorModal } from '../context/ErrorModalContext';
import { setErrorModalOpener } from '../lib/api-interceptor';

export const useErrorModalInterceptor = () => {
  const { showError } = useErrorModal();

  useEffect(() => {
    // Register the error modal opener with the API interceptor
    console.log('🔐 Registering error modal opener with API interceptor');
    setErrorModalOpener(showError);

    // Cleanup on unmount (optional, but good practice)
    return () => {
      setErrorModalOpener(null);
    };
  }, [showError]);
};